import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-prod-grp4-menu',
  templateUrl: './prod-grp4-menu.component.html',
  styleUrls: ['./prod-grp4-menu.component.css']
})
export class ProdGrp4MenuComponent implements OnInit {
    prodGrp4Id;

    public menu?: Menu;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.prodGrp4Id = this.stateService.getStateParams()['prodgrp4_id'];
    }

    private async loadMenu() {
        if (!!this.prodGrp4Id) {
            this.menu = (await this.datatask.Post(3083, { prodgrp4_id: this.prodGrp4Id }))[0];
        }
    }

    private async init() {
        this.loadMenu();
    }

    ngOnInit() {
        this.init();
    }
}

interface Menu {
    prodgrp3_id: number;
    prodgrp_name: string;
    prodgrp4_id: number;
    prodgrp4_name: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('prodGrp4Menu', {
//        templateUrl: 'views/components/views/prodGrp4Menu/prodGrp4Menu.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'prodGrp4MenuService', function ($stateParams, prodGrp4MenuService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let prodGrp4Id = $stateParams.prodgrp4_id;

//            vm.model = {
//                menu: {}
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadMenu() {
//                vm.model.menu = (await prodGrp4MenuService.getMenu({ prodgrp4_id: prodGrp4Id }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadMenu();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
